// extracted by mini-css-extract-plugin
export default {"tabs":"GenericTabs_tabs__OnMaO"};